/** White vector version of the supplied ScheduleDrop calendar/drop mark. */
export default function BrandLogo({ className = "h-8 w-8" }) {
  return (
    <svg viewBox="166 173 155 154" className={className} role="img" aria-label="ScheduleDrop logo" fill="currentColor">
      <path d="M171 234v-8c0-20 13-33 33-33h4v-7a9 9 0 0 1 18 0v7h36v-7a9 9 0 0 1 18 0v7h23c8 0 13 6 13 14s-5 13-13 13h-94c-17 0-29 5-38 14Z" />
      <path d="M316 224v61c0 23-15 38-38 38h-69c-24 0-38-14-38-37 0-34 10-52 38-52h27c-10 17-21 35-21 48 0 16 12 26 29 26s29-10 29-26c0-13-11-31-22-48h51c7 0 11-3 14-10Z" />
    </svg>
  );
}
